import React,{useState,useEffect,useCallback} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';

/*----function with pagination----*/

const pageSize = 5;

const CorpGBImagesMain = () => {
  

  const [allusers,setAllusers]= useState([])

  const [paginatedPosts, setpaginatedPosts] = useState();
  //const [currentPage, setcurrentPage] = useState(1);

  const [EditCorpLink ,SetEditCorpLink] =useState([]);
  const [OldLink ,SetOldLink] =useState([]);


  const [fileA, setFileA] = useState();
  const [fileB, setFileB] = useState();
        // console.log(file)


        const handleFileChangeA= (e) => {

          setFileA(e.target.files[0]);
          setFileB(e.target.value)
      
          console.log(fileB,"wertj")
          document.getElementById("Corpchangeinput").reset()
          // setTimeout(() => {
          //   setFileB( )
          // }, 1000);
        };
        const handleFileChangeB = (e) => {
        
            setFileB(e.target.files[0]);
        
        };


       useEffect(()=>{
        getCorpGBCapandimg();
        getRoleData();
        getCorpRoles();
        getcorpuserRole();

   
        
      },[])
    
    
      function getRoleData(){
        let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
        
       let UserRole =  localStorage.getItem("Role");
      
       const body ={
        
        role:UserRole
      
       }
       console.log(body);
      
      
        axios({          
           method: "POST", 
           url: `${BASE_URL}/Kdpcorp/GetCorpLoginUserRole`,      
          //  url: "https://localhost:44312/Api/Tc/GetTcloginUserRole",
           data:body,
           headers: {             
             'Content-Type': 'application/json' , 
             'Authorization':bearer     
           }
         
         })
         .then((response) =>{
          console.log(response.data);
          localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));
          
           }) 
         
          }
    
          // const[Roletable, setRoletable] =useState([])
    
          function getCorpRoles(){
              const token = JSON.parse(localStorage.getItem('usertoken'));
            
             
          
              fetch(`${BASE_URL}/Kdpcorp/GetCorpAddRole`, {
                method:'GET',
          
              headers : {
          
                "Content-type": "application/json",
          
                "Accept": "application/json",
          
                "Authorization": "Bearer " +`${token}`,
          
                "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
              },
          
          
          })
          
          .then(response => response.json())
          
          
          .then(data => {
          console.log("Section",data)
          localStorage.setItem("CorpRoledata", JSON.stringify(data));
          
          });
          }
          
          // --------------------//
    
      function getcorpuserRole(){
    
          let Corprole =  localStorage.getItem("loginUserRoleaction");
          let roledata =  JSON.parse(Corprole);
          let role = roledata.map((e)=>e.userroleaction);
          console.log(role);
          
          let roles = role.toString();
          let roleResult = roles.includes('Add')
          console.log(roleResult)
          
          let roleResultA = roles.includes('View')
          console.log(roleResultA)
          
          let roleResultB = roles.includes('Edit')
          console.log(roleResultB)
          
          let roleResultC = roles.includes('Delete')
          console.log(roleResultC)
          
          let empty = roles.includes('')
          console.log(empty)
    
         let roleid = localStorage.getItem('RoleId')
         let id = roleid.includes('01')
         console.log(id)
          
    
    
         if(id==true&&empty==true&&roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==false)
         {
          setCorpdisplay(true);
          setCorpEditdisplay(true);
          setCorpDeletedisplay(true);
         
         }
         if(id==false&&empty==true&&roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==false)
         {
          setCorpdisplay(false);
          setCorpEditdisplay(false);
          setCorpDeletedisplay(false);
           document.getElementById('Corp-Tbl').style.display ="none";
           document.getElementById('Corp-adduser-button').style.display ="none";
           document.getElementById('CorpGBcaption').style.display ="none";
           document.getElementById('Corpfilesize').style.display ="none";
           document.getElementById('Corpaction-err').innerHTML = 'Not Assign'
           document.getElementById('Corpaction-err').style.color = "red"
           document.getElementById('Corpaction-err').style.fontWeight = "bold"
           document.getElementById('Corpaction-err').style.alignItems = "center"
           document.getElementById('Corpaction-err').style. justifyContent = "center"
           document.getElementById('Corpaction-err').style. display= "flex"
    
          
         }
    

          if(roleResult==true){
            setCorpdisplay(false)
          }
    
          if(roleResultA==true){
           
            setCorpdisplay(false);
            
           document.getElementById('Corp-adduser-button').style.display ="none";
           document.getElementById('CorpGBcaption').style.display ="none";
           document.getElementById('Corpfilesize').style.display ="none";
         }
    
         if(roleResultB==true){
    
          document.getElementById('Corp-adduser-button').style.display ="none";
          document.getElementById('CorpGBcaption').style.display ="none";
          document.getElementById('Corpfilesize').style.display ="none";
          setCorpDeletedisplay(false);
          setCorpdisplay(true);
         }
    
         if(roleResultC==true){
          document.getElementById('Corp-adduser-button').style.display ="none";
          document.getElementById('CorpGBcaption').style.display ="none";
          document.getElementById('Corpfilesize').style.display ="none";
          setCorpEditdisplay(false);
         }
    
    
         /*---- Show add edit delete view----*/
    
        if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==true){
          setCorpdisplay(true);
          setCorpEditdisplay(true);
          setCorpDeletedisplay(true);
          document.getElementById('Corp-adduser-button').style.display ="block";
          document.getElementById('CorpGBcaption').style.display ="block";
          document.getElementById('Corpfilesize').style.display ="block";
    
        }
    
       
    
         /*---- Show delete and edit view----*/
    
         if(roleResult==true&&roleResultA==true&&roleResultC==true){
          setCorpdisplay(true);
          setCorpEditdisplay(false);
          setCorpDeletedisplay(true);
          document.getElementById('Corp-adduser-button').style.display ="block";
          document.getElementById('CorpGBcaption').style.display ="block";
          document.getElementById('Corpfilesize').style.display ="block";
    
        }
    
        
    
        
    
    
        /*---- Show add edit ----*/
    
        if(roleResult==true&&roleResultB==true){
          setCorpdisplay(true);
          setCorpEditdisplay(true);
          setCorpDeletedisplay(false);
          document.getElementById('Corp-adduser-button').style.display ="block";
          document.getElementById('CorpGBcaption').style.display ="block";
          document.getElementById('Corpfilesize').style.display ="block";
    
        }
    
     /*---- Show add view----*/ 
    
      if(roleResult==true&&roleResultA==true){
      setCorpdisplay(false);
      setCorpEditdisplay(false);
      setCorpDeletedisplay(false);
      document.getElementById('Corp-adduser-button').style.display ="block";
      document.getElementById('CorpGBcaption').style.display ="block";
      document.getElementById('Corpfilesize').style.display ="block";
    
    }
    
    
    /*---- Show edit delete ----*/
    
    if(roleResultB==true&&roleResultC==true){
      setCorpdisplay(true);
      setCorpEditdisplay(true);
      setCorpDeletedisplay(true);
      document.getElementById('Corp-adduser-button').style.display ="none";
      document.getElementById('CorpGBcaption').style.display ="none";
      document.getElementById('Corpfilesize').style.display ="none";
    
    }
    
    
    /*---- Show edit view----*/
    
    if(roleResultA==true&&roleResultB==true){
      setCorpdisplay(true);
      setCorpEditdisplay(true);
      setCorpDeletedisplay(false);
      document.getElementById('Corp-adduser-button').style.display ="none";
      document.getElementById('CorpGBcaption').style.display ="none";
      document.getElementById('Corpfilesize').style.display ="none";
    
    }
    
    
    
    
    
    /*---- Show delete view----*/
    
    if(roleResultA==true&&roleResultC==true){
      setCorpdisplay(true);
      setCorpEditdisplay(false);
      setCorpDeletedisplay(true);
      document.getElementById('Corp-adduser-button').style.display ="none";
      document.getElementById('CorpGBcaption').style.display ="none";
      document.getElementById('Corpfilesize').style.display ="none";
    
    }
    
    
    /*---- Show add edit view----*/
    
    if(roleResult==true&&roleResultA==true&&roleResultB==true){
      setCorpdisplay(true);
      setCorpEditdisplay(true);
      setCorpDeletedisplay(false);
      document.getElementById('Corp-adduser-button').style.display ="block";
      document.getElementById('CorpGBcaption').style.display ="block";
      document.getElementById('Corpfilesize').style.display ="block";
    
    }
    
    /*---- Show add delete  view----*/
    
    if(roleResult==true&&roleResultC==true){
      setCorpdisplay(true);
      setCorpEditdisplay(false);
      setCorpDeletedisplay(true);
      document.getElementById('Corp-adduser-button').style.display ="block";
      document.getElementById('CorpGBcaption').style.display ="block";
      document.getElementById('Corpfilesize').style.display ="block";
    
    }
    
      
    
    /*---- Show edit delete view----*/
    
    if(roleResultA==true&&roleResultB==true&&roleResultC==true){
      setCorpdisplay(true);
      setCorpEditdisplay(true);
      setCorpDeletedisplay(true);
      document.getElementById('Corp-adduser-button').style.display ="none";
      document.getElementById('CorpGBcaption').style.display ="none";
      document.getElementById('Corpfilesize').style.display ="none";
    
    }
    
        /*---- Show add edit delete view----*/
    
        if(roleResult==true&&roleResultB==true&&roleResultC==true){
          setCorpdisplay(true);
          setCorpEditdisplay(true);
          setCorpDeletedisplay(true);
          document.getElementById('Corp-adduser-button').style.display ="block";
          document.getElementById('CorpGBcaption').style.display ="block";
          document.getElementById('Corpfilesize').style.display ="block";
    
        }
    
      
      }
            
      const[Corpdisplay, setCorpdisplay] =useState(true);
      const[CorpEditdisplay, setCorpEditdisplay] =useState(true);
      const[CorpDeletedisplay, setCorpDeletedisplay] =useState(true);
    
    
    


    
    
        // *----Add Image and Text----*/
    
        const [file, setFile] = useState();
          
        // console.log(file)
        
        const handleFileChange = (e) => {
         
            setFile(e.target.files[0]);
        
        };


/*------Addsection------*/


function CorpAddGBImages (){

  
    var caption = document.getElementById('CorpGBcaption').value; 
    const token = JSON.parse(localStorage.getItem('usertoken'));
        

    if(!caption){
      document.getElementById("CorpGBimgErr").innerHTML="Caption Required";
    }
    else if(caption){
      document.getElementById("CorpGBimgErr").innerHTML=" ";
    }

    if(!file){
      document.getElementById("CorpGBimgErrA").innerHTML="Image Required";
    }

    else if(file){
      document.getElementById("CorpGBimgErrA").innerHTML=" ";
    }
    
    if(caption&&file){
   
   
    const body ={
     
      Caption:caption ,
      Image:file,
     
      DeleteStatus:0
  
    }
    console.log(body);


      axios({
    
        method: "POST",
    
        url: `${BASE_URL}/Kdpcorp/CorpAddGBImages`,
        data:body,
        headers: {
          
          'Content-Type': 'multipart/form-data' ,      
          "Authorization": "Bearer " +`${token}`,
        }
      
      })
     
      .then((response) =>{
        console.log(response.data);
        if(response.data.status === "Error"){
     
                alert("InCorrect")
              }
          
              else if(response.data.status === "Success"){

                alert("Added Successfully!")
          
             
                  setTimeout(() => {
                    getCorpGBCapandimg();
                    document.getElementById('CorpGBImageform').reset();
                    setFile();
                    // closeForm()
                  }, 500);
                }
               
         })


         
         .catch(error => {
        console.log(error);
         alert("failed !")       
         })
     
        } 
      }

/*---Get Caption and Image----*/

const[imgGBtable, setimgGBtable] =useState([])

        
function getCorpGBCapandimg(){
  const token = JSON.parse(localStorage.getItem('usertoken'));

 

  fetch(`${BASE_URL}/Kdpcorp/GetCorpGBImages`, {
    method:'GET',

  headers : {

    "Content-type": "application/json",

    "Accept": "application/json",

    "Authorization": "Bearer " +`${token}`,

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  },


})

.then(response => response.json())


.then(data => {
console.log("Section",data)
setAllusers(data)
      setpaginatedPosts(_(data).slice(0).take(pageSize).value());
      localStorage.setItem("CorpGBImagesData", JSON.stringify(data));
});

console.log("check",allusers)
}

// const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
//   // if (pageCount === 1)
//   // return null;
  
//   const pages = _.range(1, pageCount+1)
  
//   const pagination =(pageNo)=>{
//   setcurrentPage(pageNo);
//   const startIndex = (pageNo - 1) * pageSize;
//   const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
//   setpaginatedPosts(paginatedPost)
//   }

function closeForm(){

setFile();

document.getElementById('DisplayEditPop').style.display="none";
document.getElementById('CorpeditGBimgform').reset();
document.getElementById('modalEditForm').style.display="none";
document.getElementById('form').reset();

document.getElementById("UpdateGBcapErrA").innerHTML=" ";


}

// --------------------//

/*----Get select to the particular Id----*/
  const [EditCorpGBimg ,SetEditGBCorpimg] =useState([]);

//-----EDIT FUNCTION -----//

function CorpEditGBimg(Id){

    document.getElementById("DisplayEditPop").style.display = "block";

    CorpGBimgSelectfunction(Id)

  }


  /*----UpdateSection----*/

  function updateCorpGBimg(Id,Caption){
    const token = JSON.parse(localStorage.getItem('usertoken'));

    var Caption= document.getElementById('CorpGBcap').value; 
    // var pic=document.getElementById('imgGBtext').value;
    var OldImage = OldLink;

      if(!Caption){

        document.getElementById("UpdateGBcapErrA").innerHTML="Caption Required";
       }

       else if(Caption){
        document.getElementById("UpdateGBcapErrA").innerHTML=" ";


     }

    
     if(Caption){
    
        const body ={
      
       Id:Id,
       Image:fileA,
       oldImage:OldImage,
       Caption:Caption,
      //  oldImage:pic
      
     }
     console.log(body);
 
 
       axios({
     
         method: "POST",
         
         url: `${BASE_URL}/Kdpcorp/CorpEditGBImage`,
         data:body,
         headers: {
           
           'Content-Type': 'multipart/form-data' ,    
           "Authorization": "Bearer " +`${token}`  
          
         }
       
       })
      
       .then((response) =>{
         console.log(response.data);
         if(response.data.status === "Error"){
      
                alert("InCorrect")
               }
           
               else if(response.data.status === "Success"){

                alert("Updated Successfully!")
                
                setFileA();
                setFileB();
                
                   setTimeout(() => {
                    getCorpGBCapandimg()
                     closeForm()
                   }, 500);
                 }
                
          })
 
        .catch(error => {
         console.log(error);
          alert("failed !")       
          })
       }
      }



    /*----del btn Onclick func----*/

function  CorpGBDeleteStatus(Id){

    const token = JSON.parse(localStorage.getItem('usertoken')); 
  
    const body ={
      id: Id
    }
     console.log('check',body)
      axios({
     
      method:"POST",
     url:`${ BASE_URL}/Kdpcorp/CorpGBImagesDelete`,
     data:body,
     headers: {
     "Content-Type" : "application/json",
     "Authorization": "Bearer " + `${token}`,
  
   
     }
    
      })
      .then((response) =>{
      console.log(response.data);

      alert("Deleted Successfully !")
      // toast.info("Deleted Successfully !", {
      //  position: "top-center",
      //  autoClose: 3200,
      //  hideProgressBar: false,
      //  closeOnClick: true,
      //  pauseOnHover: true,
      //  draggable: true,
      //  progress: undefined,
      //  className: 'toast-message'
      //  });
       setTimeout(() => {
        closeForm()
        getCorpGBCapandimg();
       }, 500);
     
   
      })
   
  }
  
  
  
  function ConfirmDelete(Id){
  
  
  
    document.getElementById("modalEditForm").style.display = "block";
    CorpGBimgSelectfunction(Id)
  
  }
  
  function CorpGBimgSelectfunction(Id){
  
    const token = JSON.parse(localStorage.getItem('usertoken'));
  

    setFileA();
    setFileB();

    const body =
      {
        
       id:Id
      }
      console.log('body',body);
  
    
      axios({
             method:"POST",
             url :`${BASE_URL}/Kdpcorp/SelectCorpGBImageContent`,
             data:body, 
             headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer " +`${token}` 
              }     
          }) 
          
     
          .then((response) =>{
            console.log(response.data);
       
       
            SetEditGBCorpimg(response.data);



            localStorage.setItem("SetCorpGBI", JSON.stringify(response.data));
            let checkLink=JSON.parse(localStorage.getItem('SetCorpGBI'));
            let Check =checkLink.map((item) => item.image)
            let CheckA = Check[0]
            SetOldLink(CheckA)
                let CheckB= CheckA.slice(24);
                SetEditCorpLink(CheckB)
                console.log("srdt",CheckB)
  
       
         })
         .catch(error => {
           console.log(error);
           
         })
  
   }
 
   
   const LEFT_PAGE = "LEFT";
 const RIGHT_PAGE = "RIGHT";
 const range = (from, to, step = 1) => {
   let i = from;
   const range = [];
 
   while (i <= to) {
     range.push(i);
     i += step;
   }
 
   return range;
 };
 
 const [currentPage, setCurrentPage] = useState(1);
 
 let data = localStorage.getItem("CorpGBImagesData")
 let transdata =  JSON.parse(data);

 let NUM_OF_RECORDS = transdata.length;
 let LIMIT = 5;
 
 const onPageChanged = useCallback(
 
   (event, page) => {
     event.preventDefault();
     setCurrentPage(page);
   },
   [setCurrentPage]
   
 );
 
 
 const currentData = transdata.slice(
   (currentPage - 1) * LIMIT,
   (currentPage - 1) * LIMIT + LIMIT
 );
 
 const Paginations = (props) => {
   const {
     totalRecords,
     pageLimit,
     pageNeighbours,
     onPageChanged,
     currentPage
   } = props;
   const [totalPages, setTotalPages] = useState(0);
   useEffect(() => {
     setTotalPages(Math.ceil(totalRecords / pageLimit));
   }, [setTotalPages]);
 
   const fetchPageNumbers = () => {
     const totalNumbers = pageNeighbours * 1 + 0;
   
     const totalBlocks = totalNumbers + 2;
    
     if (totalPages > totalBlocks) {
       const startPage = Math.max(2, currentPage - pageNeighbours);
       const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
 
       let pages = range(startPage, endPage);
 
       const hasLeftSpill = startPage > 2;
       const hasRightSpill = totalPages - endPage > 1;
       const spillOffset = totalNumbers - (pages.length + 1);
 
       switch (true) {
         case hasLeftSpill && !hasRightSpill: {
           const extraPages = range(startPage - spillOffset, startPage - 1);
           pages = [LEFT_PAGE, ...extraPages, ...pages];
           break;
         }
         case hasLeftSpill && hasRightSpill:
         default: {
           pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
           break;
         }
       }
       return [1, ...pages, totalPages];
     }
     return range(1, totalPages);
   };
 
 
   const pages = fetchPageNumbers() || [];
   return (
     <nav aria-label="Countries Pagination">
       <ul className="pagination" id='Paro-pag'>
         {pages.map((page, index) => {
           if (page === LEFT_PAGE)
             return (
               <li key={index} className="Corppage-item">
                 <a
                   href="/"
                   className="page-link"
                   aria-label="Previous"
                   onClick={(e) => onPageChanged(e, pageNeighbours)}
                 >
                   <span aria-hidden="true">&laquo;</span>
                 </a>
               </li>
             );
 
           if (page === RIGHT_PAGE)
             return (
               <li key={index} className="Corppage-item">
                 <a
                   className="page-link"
                   href="/"
                   aria-label="Next"
                   onClick={(e) => onPageChanged(e, pageNeighbours*2+1 )}
                 >
                   <span aria-hidden="true">&raquo;</span>
                 </a>
               </li>
             );
 
           return (
             <li
               key={index}
               className={`Corppage-item${currentPage === page ? " active" : ""}`}
             >
               <a
                 className="page-link"
                 href="/"
                 onClick={(e) => onPageChanged(e, page)}
               >
                 {page}
               </a>
             </li>
           );
         })}
       </ul>
     </nav>
   );
 };


  return (
    <>
    <div className='Corp-addmain'>

    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 

    <div className="Corp-addgrid-layout">
  <div className="Corp-addmain-top">
    <div className='Corp-addmain-back'>
    <Link to='/CorpGivingback'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Giving back</span>
    
    </div>
    </div>

    <span id="Corpaction-err"></span>


    <div className='Corp-lifetable'>
{/* <div className="Corp-table_responsivebox"> */}


<form id='CorpGBImageform'onSubmit={CorpAddGBImages} >
<div className="modal-body mx-4">

<div className='col-sm-12'>
<div className='row'>


<div className='col-sm-4'> 
<div className="md-form mb-0">
<input type="text" id='CorpGBcaption' placeholder='Caption'/>
<br></br>
<span id="CorpGBimgErr" className='error'></span>

</div>
</div>

<div className='col-sm-4'> 
<div className="md-form mb-0">
<input type="file"id="Corpfilesize"  placeholder='Image' onChange={handleFileChange}/>
<br></br>
<span id="CorpGBimgErrA" className='error'></span>

</div>
</div>

<div className='col-sm-4'> 
<div className="md-form mb-0">
<div className='text-center' id="CorpAddbtnres">
<button className='Corp-btnadduser-button' id="Corp-adduser-button" type='submit'>ADD</button>
</div>
</div>
</div>

</div>
</div>
</div>




</form>




{/* </div> */}
</div>


<div className='Corp-Lifeheretable'>
<div class="Corp-table_Liferesponsive" id="Corp-Tbl">


{
  !paginatedPosts ? ("No data found"):(<table> 
    <thead>
   <tr>
<th>Caption</th>
<th>Image</th>
{Corpdisplay?<th>Action</th>:null}

</tr>
</thead>
<tbody>

  {/* mapping to adduser */}

  {currentData.map((e)=>
            {
              return<tr>
                <td><div style={{inlineSize:"600px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.caption}</div></td>
                <td className='text-center'><img src={e.image} id="section-image"/></td>
                {Corpdisplay?<td className='text-center' style={{whiteSpace:"nowrap"}}>
                
                {CorpEditdisplay?<i class="fa fa-pencil" aria-hidden="true" onClick={()=>CorpEditGBimg(e.id)} id="CorpEdit-icon"></i>:null}&nbsp;&nbsp;
                {CorpDeletedisplay?<i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id,e.userName)} id="CorpDelete-icon"></i>:null}
              
              </td>:null}

              </tr>
            })}
</tbody>

</table>
  )}

<br></br>

{transdata.length<=5? null:<div>{

!paginatedPosts ? (""):(

<Paginations



totalRecords={NUM_OF_RECORDS}

pageLimit={LIMIT}

pageNeighbours={2}

onPageChanged={onPageChanged}

currentPage={currentPage}

/>

)}
</div>
}

  {/* <nav>
    <ul className='pagination'>
      {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      }
       

    </ul>
  </nav> */}

</div>
 </div>

 {/* EditPopup */}

<div className='Paropop-fade' id="DisplayEditPop">
{EditCorpGBimg.map((e)=>{
   return<div className="modal-dialog" role="document" id="CorpcenterEditform">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="CorpeditGBimgform" onSubmit={()=>updateCorpGBimg(e.id,e.caption,e.image)}>
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
        <label id="ParoSectionTable">Caption</label> 
          <input type="text" id="CorpGBcap"  defaultValue={e.caption}/>
          <span id="UpdateGBcapErrA" className='error'></span>
        </div> 

        {/* <div className="md-form mb-5">
        <label id="ParoSectionTable">Image</label> 
         <input type="file" onChange={handleFileChange}/>
         <input type="text" id="imgGBtext" value={e.image}/>
         <span id="UpdateGBcapErrB" className='error'></span>
        </div> */}


<div className="md-form mb-5">
        <label id="ParoSectionTable">Image</label> 
        {!fileA? <div>
          <input type="file"  style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChangeA} id="ParotextG"/>

<div style={{border:"1px solid lightgrey" ,padding:"1px 12px 1px 12px",borderRadius:"2px",marginTop:"-50px"}}>
<input defaultValue={EditCorpLink}  id="oldEventFound"style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
 <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
 {/* &nbsp;<span >{e.fileName}</span> */}
 </div>

</div> 
         
        
        :
<div>
        <form id="Corpchangeinput"><input type="file" style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChangeA}/>
        <div style={{border:"1px solid lightgrey" ,padding:"1px 12px 1px",borderRadius:"2px",marginTop:"-50px",color:"red"}}>
        <input defaultValue={fileB}  style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
         <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
      
         </div></form> <input defaultValue={e.image} id="oldEventFound" style={{display:"none"}} />
                        
                        </div>
                        }
                          <span id="UpdateGBcapErrB" className='error'></span>
       
      
     

                          </div>
        


      </div>

      <div className="modal-footer d-flex justify-content-center">
        <button className='Corp-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>



<div className="Paropop-fade" id="modalEditForm" tabindex="-1" role="dialog">
{EditCorpGBimg.map((e)=>{
   return<div className="modal-dialog" role="document" id="CorpcenterDelform">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">DELETE</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>

   <div className="modal-body mx-3">

        <div className="md-form mb-5">
            <div className='text-center'>
          <h5>Are you sure want to delete?</h5>
          </div>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <button className="Corp-logout-button" type='submit' onClick={()=>CorpGBDeleteStatus(e.id,e.userName)}>Confirm</button>
        <button className="Corp-logout-button" onClick={closeForm} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
  })}
</div>


    </div>
    </>

  )
}

export default CorpGBImagesMain